import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import appStore from 'stores/app';
import Formsy from 'formsy-react';
import history from 'utils/history';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Label, FormGroup, SheetFooter, DefaultTooltip, SheetBody, Textarea } from 'twyne-new.ui';
import Input from 'components/form/Input';
import Switch from 'components/form/Switch';
import Select from 'components/form/Select';
import AutocompleteInput from 'components/AutocompleteInput/index';
import { useGlobalStore } from '@Stores/global';
import { MessageCircleQuestion } from 'lucide-react';

const propTypes = {
	handleSubmit: PropTypes.func,
	data: PropTypes.any
};

const maxLines = 25000
export default class BlacklistForm extends React.Component {
	state = {
		redirect_enabled: false,
		active: true,
		lines: [],
		value: '',
		blockInput: false
	}

	componentWillMount() {
		let data = this.props.data;
		if (data) {
			data.redirect_enabled = !!data.redirect_url
			this.setState(data);
		}
	}

	handleChangeType = (option) => {
		const type = option ? option.value : null;
		if (type == 'not-ip-country' || type == 'ip-country') {
			this.setState({ global: false });
		}
		this.setState({ type });
		this.filterLines()
	}

	handleChangeRedirectEnable = (redirect_enabled) => {
		this.setState(() => {
			const newState = { redirect_enabled }
			if (!redirect_enabled)
				newState.redirect_url = null
			return newState
		})
	}

	isExistingBlacklist = value => {
		const { blacklists } = this.props
		const { type } = this.state
		const blackListsByType = blacklists.filter(o => o.type === type).map(o => o.value)
		const alreadyblackListed = blackListsByType.filter(o => o === value)
		return alreadyblackListed.length > 0
	}

	isDuplicatedOnList = (l, i) => {
		const { lines } = this.state
		const alreadyOnList = lines.filter(o => {
			return o === l && i > lines.indexOf(o)
		})
		return alreadyOnList.length > 1
	}

	isValid = value => {
		return value && value.trim().length > 0
	}

	filterLines = () => {
		const filtered = []
		this.state.lines.forEach((l, i) => {
			if (this.isValid(l) && !this.isDuplicatedOnList(l, i) && !this.isExistingBlacklist(l)) {
				filtered.push(l)
			}
		})
		this.setState({ lines: filtered })
		return filtered
	}

	handleTextChange = async evt => {
		const { value } = evt.target
		const lines = value.split("\n").map(l => l.trim())
		await this.setState({ lines })
		const filtered = this.filterLines()

		if ((filtered.length >= maxLines && value.endsWith('\n'))) {
			const valueSliced = value.split('\n').slice(0, maxLines)
			await this.setState({ blockInput: true, value: valueSliced.join('\n'), lines: valueSliced })
		} else {
			await this.setState({ value })
		}
	}

	handleValidSubmit = async model => {
		model.value = `${model.value || this.state.value}`
		this.props.handleSubmit(Object.assign(this.state, model))
	}

	handleCancel = () => {
		if (this.props.onCancel) {
			this.props.onCancel();
		} else {
			history.goBack();
		}
	}

	renderInputValue = () => {
		if (this.state.type && this.state.type.endsWith('ip-country'))
			return <Select name="value"
				closeOnSelect={false}
				multi
				options={COUNTRIES}
				value={Array.isArray(this.state.value) ? this.state.value : this.state.value ? this.state.value.split(',') : []}
				handleOnChange={selecteds => {
					this.setState({ value: selecteds.map(sel => sel.value) })
				}}
			/>

		return <Input name="value" value={this.state.value} required />
	}

	renderInput = () => {
		return <Col size="6">
			<FormGroup>
				<Label>Value</Label>
				<DefaultTooltip content={typeCaption[this.state.type]} triggerProps={{ className:'w-full text-left' }}>
					{this.renderInputValue()}
				</DefaultTooltip>
			</FormGroup>
		</Col>
	}

	renderTextAreaInput = () => {
		return <Col size="12">
			<FormGroup>
				<Label style={{ color: this.state.lines.length >= maxLines ? 'red' : '' }}>
					Values ({`${this.state.lines.length}/${maxLines}`})
					<Link to='#' id='input-textarea-help'>
						<DefaultTooltip content='One blacklist per line.'>
							<MessageCircleQuestion size={12} className='ml-1 twy-text-accent' />
						</DefaultTooltip>
					</Link>
				</Label>
				<Textarea
					name="input_lines"
					type="textarea"
					onChange={this.handleTextChange}
					value={this.state.value}
					disabled={this.state.blockInput} 
					rows="10"
				/>
			</FormGroup>
		</Col>
	}

	AutocompleteUrlInput = () => {
    const [mergetags, setMergetags] = useState([])
    const { customFields: { getFields }, metaFields: { getFields: getMetaFields } } = useGlobalStore()

    const loadMergetags = useCallback(async () => {
      const allFields = await appStore.getFields()
      const customFields = await getFields()
      const metaFields = await getMetaFields()
      const mergetags = [...allFields]
      customFields.forEach(({ key, private: _private }) => !_private && mergetags.push(`cf_${key}`, `cf_${key}_urlencoded`) )
      metaFields.forEach(({ key }) => mergetags.push(key) )
      setMergetags(mergetags)
    }, [getFields, getMetaFields])

    useEffect(() => {
      loadMergetags()
    }, [loadMergetags])

		if (!this.state.redirect_enabled)
			return null

		return <Col xs="10">
			<FormGroup>
				<Label>URL</Label>
				<AutocompleteInput
					className="form-control"
					trigger={["{"]}
					options={{"{": mergetags }}
					value={this.state.redirect_url || ''}
					onChange={(value) => this.setState({ redirect_url: value }) }
					maxOptions={0}
					maxlength={255}
					required
				/>
			</FormGroup>
		</Col>
	}

	getTypeOptions = () => {
		const { bulk } = this.props
		return typeOptions.filter(o => !(bulk && o.value.endsWith('ip-country')))
	}

	render() {
		return (
			<Formsy onValidSubmit={this.handleValidSubmit}>
				<SheetBody>
					<Row>
						<Col size="6">
							<FormGroup>
								<Label>Type</Label>
								<Select name="type" value={this.state.type}
									options={this.getTypeOptions()}
									handleOnChange={this.handleChangeType} />
							</FormGroup>
						</Col>
						{this.props.bulk ? this.renderTextAreaInput() : this.renderInput()}
						<this.AutocompleteUrlInput />
						<Col size="2">
							<FormGroup>
								<Label>Active</Label>
								<Switch name="active" value={this.state.active || false} />
							</FormGroup>
						</Col>
						<Col size="2">
							<FormGroup>
								<Label>Redirect</Label>
								<Switch name="redirect_enabled" value={this.state.redirect_enabled} setValue={this.handleChangeRedirectEnable} />
							</FormGroup>
						</Col>
						<Col size="8">
							{!this.state.type || !this.state.type.endsWith('ip-country') ?
								<FormGroup>
									<Label>Global</Label>
									<Switch name="global" value={this.state.global || false} />
								</FormGroup> : null
							}
						</Col>
					</Row>
				</SheetBody>
				<SheetFooter>
					<Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
					<Button type="submit" color="accent">Save</Button>
				</SheetFooter>
			</Formsy>
		);
	}
}

const typeOptions = [
	{ value: 'ip-country', label: 'IP Country' },
	{ value: 'not-ip-country', label: 'Not IP Country' },
	{ value: 'domain', label: 'Domain' },
	{ value: 'email', label: 'e-mail' },
	{ value: 'phone', label: 'Phone number' },
	{ value: 'ip', label: 'IP' }
]

const typeCaption = {
	'domain': "E-mail domain",
	'email': "Full e-mail",
	'phone': "Full phone",
	'ip-country': "Block all users from these countries",
	'not-ip-country': "Block all users EXCEPT those from these countries",
	'ip': "Full IP"
}

export const COUNTRIES = [["Afghanistan", "AF"], ["Albania", "AL"], ["Algeria", "DZ"], ["American Samoa", "AS"], ["Andorra", "AD"], ["Angola", "AO"], ["Anguilla", "AI"], ["Antarctica", "AQ"], ["Antigua and Barbuda", "AG"], ["Argentina", "AR"], ["Armenia", "AM"], ["Aruba", "AW"], ["Australia", "AU"], ["Austria", "AT"], ["Azerbaijan", "AZ"], ["Bahamas (the)", "BS"], ["Bahrain", "BH"], ["Bangladesh", "BD"], ["Barbados", "BB"], ["Belarus", "BY"], ["Belgium", "BE"], ["Belize", "BZ"], ["Benin", "BJ"], ["Bermuda", "BM"], ["Bhutan", "BT"], ["Bolivia (Plurinational State of)", "BO"], ["Bonaire, Sint Eustatius and Saba", "BQ"], ["Bosnia and Herzegovina", "BA"], ["Botswana", "BW"], ["Bouvet Island", "BV"], ["Brazil", "BR"], ["British Indian Ocean Territory (the)", "IO"], ["Brunei Darussalam", "BN"], ["Bulgaria", "BG"], ["Burkina Faso", "BF"], ["Burundi", "BI"], ["Cabo Verde", "CV"], ["Cambodia", "KH"], ["Cameroon", "CM"], ["Canada", "CA"], ["Cayman Islands (the)", "KY"], ["Central African Republic (the)", "CF"], ["Chad", "TD"], ["Chile", "CL"], ["China", "CN"], ["Christmas Island", "CX"], ["Cocos (Keeling) Islands (the)", "CC"], ["Colombia", "CO"], ["Comoros (the)", "KM"], ["Congo (the Democratic Republic of the)", "CD"], ["Congo (the)", "CG"], ["Cook Islands (the)", "CK"], ["Costa Rica", "CR"], ["Croatia", "HR"], ["Cuba", "CU"], ["Curaçao", "CW"], ["Cyprus", "CY"], ["Czechia", "CZ"], ["Côte d'Ivoire", "CI"], ["Denmark", "DK"], ["Djibouti", "DJ"], ["Dominica", "DM"], ["Dominican Republic (the)", "DO"], ["Ecuador", "EC"], ["Egypt", "EG"], ["El Salvador", "SV"], ["Equatorial Guinea", "GQ"], ["Eritrea", "ER"], ["Estonia", "EE"], ["Eswatini", "SZ"], ["Ethiopia", "ET"], ["Falkland Islands (the) [Malvinas]", "FK"], ["Faroe Islands (the)", "FO"], ["Fiji", "FJ"], ["Finland", "FI"], ["France", "FR"], ["French Guiana", "GF"], ["French Polynesia", "PF"], ["French Southern Territories (the)", "TF"], ["Gabon", "GA"], ["Gambia (the)", "GM"], ["Georgia", "GE"], ["Germany", "DE"], ["Ghana", "GH"], ["Gibraltar", "GI"], ["Greece", "GR"], ["Greenland", "GL"], ["Grenada", "GD"], ["Guadeloupe", "GP"], ["Guam", "GU"], ["Guatemala", "GT"], ["Guernsey", "GG"], ["Guinea", "GN"], ["Guinea-Bissau", "GW"], ["Guyana", "GY"], ["Haiti", "HT"], ["Heard Island and McDonald Islands", "HM"], ["Holy See (the)", "VA"], ["Honduras", "HN"], ["Hong Kong", "HK"], ["Hungary", "HU"], ["Iceland", "IS"], ["India", "IN"], ["Indonesia", "ID"], ["Iran (Islamic Republic of)", "IR"], ["Iraq", "IQ"], ["Ireland", "IE"], ["Isle of Man", "IM"], ["Israel", "IL"], ["Italy", "IT"], ["Jamaica", "JM"], ["Japan", "JP"], ["Jersey", "JE"], ["Jordan", "JO"], ["Kazakhstan", "KZ"], ["Kenya", "KE"], ["Kiribati", "KI"], ["Korea (the Democratic People's Republic of)", "KP"], ["Korea (the Republic of)", "KR"], ["Kuwait", "KW"], ["Kyrgyzstan", "KG"], ["Lao People's Democratic Republic (the)", "LA"], ["Latvia", "LV"], ["Lebanon", "LB"], ["Lesotho", "LS"], ["Liberia", "LR"], ["Libya", "LY"], ["Liechtenstein", "LI"], ["Lithuania", "LT"], ["Luxembourg", "LU"], ["Macao", "MO"], ["Madagascar", "MG"], ["Malawi", "MW"], ["Malaysia", "MY"], ["Maldives", "MV"], ["Mali", "ML"], ["Malta", "MT"], ["Marshall Islands (the)", "MH"], ["Martinique", "MQ"], ["Mauritania", "MR"], ["Mauritius", "MU"], ["Mayotte", "YT"], ["Mexico", "MX"], ["Micronesia (Federated States of)", "FM"], ["Moldova (the Republic of)", "MD"], ["Monaco", "MC"], ["Mongolia", "MN"], ["Montenegro", "ME"], ["Montserrat", "MS"], ["Morocco", "MA"], ["Mozambique", "MZ"], ["Myanmar", "MM"], ["Namibia", "NA"], ["Nauru", "NR"], ["Nepal", "NP"], ["Netherlands (the)", "NL"], ["New Caledonia", "NC"], ["New Zealand", "NZ"], ["Nicaragua", "NI"], ["Niger (the)", "NE"], ["Nigeria", "NG"], ["Niue", "NU"], ["Norfolk Island", "NF"], ["Northern Mariana Islands (the)", "MP"], ["Norway", "NO"], ["Oman", "OM"], ["Pakistan", "PK"], ["Palau", "PW"], ["Palestine, State of", "PS"], ["Panama", "PA"], ["Papua New Guinea", "PG"], ["Paraguay", "PY"], ["Peru", "PE"], ["Philippines (the)", "PH"], ["Pitcairn", "PN"], ["Poland", "PL"], ["Portugal", "PT"], ["Puerto Rico", "PR"], ["Qatar", "QA"], ["Republic of North Macedonia", "MK"], ["Romania", "RO"], ["Russian Federation (the)", "RU"], ["Rwanda", "RW"], ["Réunion", "RE"], ["Saint Barthélemy", "BL"], ["Saint Helena, Ascension and Tristan da Cunha", "SH"], ["Saint Kitts and Nevis", "KN"], ["Saint Lucia", "LC"], ["Saint Martin (French part)", "MF"], ["Saint Pierre and Miquelon", "PM"], ["Saint Vincent and the Grenadines", "VC"], ["Samoa", "WS"], ["San Marino", "SM"], ["Sao Tome and Principe", "ST"], ["Saudi Arabia", "SA"], ["Senegal", "SN"], ["Serbia", "RS"], ["Seychelles", "SC"], ["Sierra Leone", "SL"], ["Singapore", "SG"], ["Sint Maarten (Dutch part)", "SX"], ["Slovakia", "SK"], ["Slovenia", "SI"], ["Solomon Islands", "SB"], ["Somalia", "SO"], ["South Africa", "ZA"], ["South Georgia and the South Sandwich Islands", "GS"], ["South Sudan", "SS"], ["Spain", "ES"], ["Sri Lanka", "LK"], ["Sudan (the)", "SD"], ["Suriname", "SR"], ["Svalbard and Jan Mayen", "SJ"], ["Sweden", "SE"], ["Switzerland", "CH"], ["Syrian Arab Republic", "SY"], ["Taiwan (Province of China)", "TW"], ["Tajikistan", "TJ"], ["Tanzania, United Republic of", "TZ"], ["Thailand", "TH"], ["Timor-Leste", "TL"], ["Togo", "TG"], ["Tokelau", "TK"], ["Tonga", "TO"], ["Trinidad and Tobago", "TT"], ["Tunisia", "TN"], ["Turkey", "TR"], ["Turkmenistan", "TM"], ["Turks and Caicos Islands (the)", "TC"], ["Tuvalu", "TV"], ["Uganda", "UG"], ["Ukraine", "UA"], ["United Arab Emirates (the)", "AE"], ["United Kingdom of Great Britain and Northern Ireland (the)", "GB"], ["United States Minor Outlying Islands (the)", "UM"], ["United States of America (the)", "US"], ["Uruguay", "UY"], ["Uzbekistan", "UZ"], ["Vanuatu", "VU"], ["Venezuela (Bolivarian Republic of)", "VE"], ["Viet Nam", "VN"], ["Virgin Islands (British)", "VG"], ["Virgin Islands (U.S.)", "VI"], ["Wallis and Futuna", "WF"], ["Western Sahara", "EH"], ["Yemen", "YE"], ["Zambia", "ZM"], ["Zimbabwe", "ZW"], ["Åland Islands", "AX"]]
	.map(([name, value]) => ({ label: `${value} - ${name}`, value }))

BlacklistForm.propTypes = propTypes;
